import '@Global/modal';
import {createRoot} from 'react-dom/client';
import App from '@Components/app';
import {ModalContainer} from '@Components/modal-container';
import {CreateWithAiPromptBox} from '@Components/create-with-ai-prompt-box/create-with-ai-prompt-box';
import {AiChatSource} from '@Components/ai-chat-window/ai-chat-window.types';
import {AiChatStartSource} from '@Libraries/ga-events';
import {LANDING_PAGE_AI_PROMPT_BOX_ID} from './landing-page-ai-chat.types';

const container = document.getElementById(LANDING_PAGE_AI_PROMPT_BOX_ID);
if (container) {
  const root = createRoot(container);
  root.render(
    <App className="_full-width">
      <ModalContainer />
      <CreateWithAiPromptBox
        promptBoxId={LANDING_PAGE_AI_PROMPT_BOX_ID}
        chatSource={AiChatSource.SEO_LANDING_PAGE}
        startSource={AiChatStartSource.SEO_LANDING_PAGE}
        blockClasses="l-ai-chat-section-prompt-box"
        inputClasses="l-ai-chat-section-prompt-box-input"
        showTemplatesButton
        authenticateBeforeSubmit
        showInitialAnimation={false}
      />
    </App>
  );
}
